var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRadio = function SvgRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 14.5,
    x: 0.75,
    y: 0.75,
    fill: "#fff",
    rx: 7.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 14.5,
    x: 0.75,
    y: 0.75,
    stroke: "#CCC",
    strokeWidth: 1.5,
    rx: 7.25
  })));
};
export default SvgRadio;